import React from "react"

import ModalAddUser from "./components/modal-add-user"
import {AddUser_Callback, AddUser_Manager} from "./model/manager"
import Workspace from "../../model2/space/workspaces/workspace"
import ProjectSession from "../../model2/project/project-session"
import Task from "../../model2/task/task"

type AddUser_Params = {
    multiselect?        : boolean           // if false only single user can be selected
    noUsersCreation?    : boolean           // no requests will be made to create users in workspace, project or task

    excludedUserIds?    : ID[]

    callback?           : AddUser_Callback
    toggleCallback?     : {(isModalOpen: boolean): void}
}

function modalAddUser(manager: AddUser_Manager, params?: AddUser_Params) {
    manager.multiselect     = _.get(params, 'multiselect', true)
    manager.noUsersCreation = _.get(params, 'noUsersCreation', false)
    manager.callback        = params?.callback

    manager.excludeUsers(params?.excludedUserIds)

    gd.modal.showV5(
        <ModalAddUser manager={manager} />,
        {
            toggleCallback: params?.toggleCallback
        }
    )
}

export function modalAddWorkspaceUser(workspace:Workspace, params?: AddUser_Params) {
    modalAddUser(AddUser_Manager.initForWorkspace(workspace), params)
}

export function modalAddProjectUser(projectId:ID, params?: AddUser_Params) {
    // we pass user id because info app has fullproject model which has no tree root -> no workspace reference :-/
    const project : ProjectSession = gd.session.projects.get(projectId)!
    modalAddUser(AddUser_Manager.initForProject(project), params)
}

export function modalAddTaskUser(task:Task, params?: AddUser_Params) {
    modalAddUser(AddUser_Manager.initForTask(task), params)
}